export class TagModel {
    public id: number;
    public value: string;
    public createdAt: string;
    public description: string;
    public updatedAt: string;

    constructor(res: any) {
        this.id = res.id;
        this.value = res.value || '';
        this.createdAt = res.createdAt || '';
        this.description = res.description || '';
        this.updatedAt = res.updatedAt || '';
    }
}